// extracted by mini-css-extract-plugin
export var divider = "_qd-0";
export var systemMessage = "_qd-1";